import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

export interface ProfileCompletionItem {
  label: string;
  done: boolean;
}

@Component({
  selector: 'app-dashboard-profile-completion',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './dashboard-profile-completion.component.html',
  styleUrl: './dashboard-profile-completion.component.scss'
})
export class DashboardProfileCompletionComponent {
  @Input() firstName: string = 'Student';
  @Input() completionPercentage: number = 30;

  /** Section checklist, mirroring the view-profile completion sections. */
  @Input() completionItems: ProfileCompletionItem[] = [];

  constructor(private router: Router) {}

  onCompleteProfile() {
    this.router.navigate(['portal', 'application-form']);
  }
}
